import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import LoadingButton from 'src/components/UI/LoadingButton';
import { FORM, FORM_STATUS } from 'src/constants/Form';
import { putAdminsAction } from 'src/redux/actions/userActions';
import { RIGHT } from 'src/components/Elements/ManageUserAdmins';

const DeleteAdminDialog = () => {
  const dispatch = useAppDispatch();

  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.deleteAdmin]) {
        return state.dialog[DIALOGS.deleteAdmin];
      }
      return { opened: false, payload: null };
    });

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const processing = useSelector(
    (state: Store) => state.formStatus[FORM.delete_admin] === FORM_STATUS.processing,
  );

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteAdmin }));
  };

  const handleOk = () => {
    dispatch(putAdminsAction(payload.userId, RIGHT.none));
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="deleting-admin"
      open={opened}>
      <DialogTitle id="deleting-account">{t(lang, 'menus.removing_admin')}</DialogTitle>
      <DialogContent dividers>
        {t(lang, 'menus.removing_admin_confirmation')}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary" disabled={processing}>
          {t(lang, 'misc.no')}
        </Button>
        <LoadingButton onClick={handleOk} color="primary" loading={processing}>
          {t(lang, 'misc.yes')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAdminDialog;
